
/**
 * 商品图片边框（边框系统一期）
 *
 * 渲染层：absolute 撑满 position:relative 的图片容器（L5 层——
 * 真实图 L0 / 边框 L5 / tier 徽标与管理员编辑 L10），不占布局高度、
 * 不改卡片尺寸、pointer-events:none 不拦截点击。
 * asset 由 1:1 透明 PNG/WebP 线上资产构成，object-fit:fill 平铺即对齐。
 * 只包图片区，不套整卡；无绑定时组件渲染为空。
 */
export default {
  name: 'ProductFrame',
  props: {
    // 后端列表 DTO 注入的 p.frame = { asset_url } | null
    frame: { type: Object, default: null }
  },
  computed: {
    url () {
      return this.frame && this.frame.asset_url ? this.$img(this.frame.asset_url) : ''
    }
  }
}
